module.exports = __webpack_public_path__ + "img/img28.2c96e388.png";